export enum LinkNames {
  AccountLinking = 'AccountLinking',
  AccountLinkingNoShipping = 'AccountLinkingNoShipping',
  Continue = 'Continue',
  Directory = 'Directory',
  NoFlows = 'NoFlows',
  SPBv4 = 'SPBv4',
  SPBv5 = 'SPBv5',
  Vcc = 'Vcc',
  LegacyPayPal = 'LegacyPayPal',
  LegacyPayPalResult = 'LegacyPayPalResult',
  MockVcc = 'MockVcc',
  GuestPayPalButton = 'GuestPayPalButton',
}

export enum PageDetectorNames {
  FIND_SAVINGS = 'FIND_SAVINGS',
  PAYMENTS = 'PAYMENTS',
}
